var aaa_ids = ["aaa", "auto_club"];
export default function isAAAIssuer(_a) {
    var _b = _a.name, name = _b === void 0 ? "" : _b, _c = _a.id, id = _c === void 0 ? "" : _c;
    return (aaa_ids.some(function (aaaId) { return id.includes(aaaId); }) ||
        name.toUpperCase().includes("AAA"));
}
